import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { Droppable, Draggable, DragDropContext } from 'react-beautiful-dnd';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
  },
}));

const MiniTestsList = ({ data, updateData }) => {
  const [tests, setTests] = useState(data);
  useEffect(() => {
    setTests(data);
  }, [data]);
  const classes = useStyles();
  const onDragEnd = result => {
    const { destination, source, reason } = result;
    if (!destination || reason === 'CANCEL') {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }
    const testsCopy = Object.assign([], tests);
    const droppedQuestion = tests[source.index];
    testsCopy.splice(source.index, 1);
    testsCopy.splice(destination.index, 0, droppedQuestion);
    setTests(testsCopy);
    updateData(testsCopy);
  };

  const handleRemoveQuestion = (q, index) => {
    const testsCopy = Object.assign([], tests);
    const droppedQuestion = tests[index];
    testsCopy.splice(droppedQuestion, 1);
    setTests(testsCopy);
    updateData(testsCopy);
  };

  const rendertests = (d, index) => {
    return (
      <Draggable key={index} draggableId={index + ''} index={index}>
        {(provided, _) => {
          return (
            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
              <ListItem button>
                <ListItemIcon onClick={() => handleRemoveQuestion(d, index)}>
                  <DeleteOutlineIcon />
                </ListItemIcon>
                <ListItemText primary={d.quiz} />
                <DragIndicatorIcon />
              </ListItem>
            </div>
          );
        }}
      </Draggable>
    );
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className={classes.root}>
        <Droppable droppableId="dp1">
          {provided => {
            return (
              <List ref={provided.innerRef} {...provided.droppableProps} component="nav" aria-label="main mailbox folders">
                {tests.map(rendertests)}
                {provided.placeholder}
              </List>
            );
          }}
        </Droppable>
      </div>
    </DragDropContext>
  );
};

export default MiniTestsList;
